import { useMissionsTranslation } from '../../../../ui/hooks';
import { Stack } from '@mui/material';
import React from 'react';
import { MissionSelect } from '../../shift-details/components/past-shifts/MissionSelect';
import { ShiftSelect } from '../../shift-details/components/past-shifts/ShiftSelect';
export const SelectMissionShiftStep = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useMissionsTranslation();
    const [data, dispatch] = React.useReducer(reducer, props.data);
    React.useImperativeHandle(ref, () => ({
        getData: () => data,
        submit: () => {
            var _a;
            if ((_a = data.shift) === null || _a === void 0 ? void 0 : _a.id) {
                return props.onSubmit(data).then((response) => props.onSubmitSuccess(data, response));
            }
            else {
                return Promise.reject(t('shiftVolunteerManagementWizard.validation.shiftNotSelected'));
            }
        },
    }));
    const handleMissionChange = (missionId) => {
        dispatch({ type: 'set_mission', missionId });
    };
    const handleShiftChange = (shiftId) => {
        dispatch({ type: 'set_shift', shiftId });
    };
    const shiftFilters = ((_a = data.mission) === null || _a === void 0 ? void 0 : _a.id)
        ? [{ column: 'missionId', op: '=', value: data.mission.id }, ...((_b = props.additionalShiftFilters) !== null && _b !== void 0 ? _b : [])]
        : undefined;
    return (React.createElement(Stack, { spacing: 2 },
        React.createElement(MissionSelect, { value: (_d = (_c = data.mission) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '', onChange: handleMissionChange }),
        React.createElement(ShiftSelect, { disabled: !((_e = data.mission) === null || _e === void 0 ? void 0 : _e.id), value: (_g = (_f = data.shift) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : '', onChange: handleShiftChange, additionalShiftFilters: shiftFilters })));
});
const reducer = (state, action) => {
    switch (action.type) {
        case 'set_mission':
            return { mission: { id: action.missionId } };
        case 'set_shift':
            return { shift: { id: action.shiftId }, mission: state.mission ? { id: state.mission.id } : undefined };
        default:
            throw Error('Action does not exist');
    }
};
